import { Facebook, MessageCircle, Link as LinkIcon, Share2 } from "lucide-react";
import { toast } from "sonner";
import {
    Popover, PopoverContent, PopoverTrigger,
} from "@/components/ui/popover";

export default function ShareButtons({ url, title = "Self Preparation", compact = false }) {
    const fullUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    const enc = encodeURIComponent(fullUrl);
    const encTitle = encodeURIComponent(title);

    const links = [
        { name: "Facebook", url: `https://www.facebook.com/sharer/sharer.php?u=${enc}`, icon: Facebook, color: "#1877F2" },
        { name: "WhatsApp", url: `https://api.whatsapp.com/send?text=${encTitle}%20${enc}`, icon: MessageCircle, color: "#25D366" },
    ];

    const copyLink = async () => {
        try { await navigator.clipboard.writeText(fullUrl); toast.success("লিংক কপি করা হয়েছে"); }
        catch { toast.error("কপি করা যায়নি"); }
    };

    if (compact) {
        return (
            <Popover>
                <PopoverTrigger asChild>
                    <button className="px-3 py-2 rounded-lg border border-brand-light hover:bg-brand-light/40 inline-flex items-center gap-2 text-sm font-medium text-brand-navy" data-testid="share-btn">
                        <Share2 className="w-4 h-4" /> শেয়ার
                    </button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-2 font-bn" align="end">
                    <div className="flex gap-1.5">
                        {links.map((l) => {
                            const Icon = l.icon;
                            return (
                                <a key={l.name} href={l.url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-lg grid place-items-center text-white hover:scale-110 transition" style={{ background: l.color }} data-testid={`share-${l.name.toLowerCase()}`}>
                                    <Icon className="w-4 h-4" />
                                </a>
                            );
                        })}
                        <button onClick={copyLink} className="w-9 h-9 rounded-lg grid place-items-center bg-brand-navy text-white hover:scale-110 transition" data-testid="share-copy">
                            <LinkIcon className="w-4 h-4" />
                        </button>
                    </div>
                </PopoverContent>
            </Popover>
        );
    }

    return (
        <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
            <span className="text-xs text-brand-navy/60 font-medium">শেয়ার করুন:</span>
            {links.map((l) => {
                const Icon = l.icon;
                return (
                    <a key={l.name} href={l.url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full grid place-items-center text-white hover:scale-110 transition shadow-soft" style={{ background: l.color }}>
                        <Icon className="w-4 h-4" />
                    </a>
                );
            })}
            <button onClick={copyLink} className="w-9 h-9 rounded-full grid place-items-center bg-brand-navy text-white hover:scale-110 transition shadow-soft">
                <LinkIcon className="w-4 h-4" />
            </button>
        </div>
    );
}
